// @ts-nocheck
/* eslint-disable */
import { StatusCodes } from 'http-status-codes';
import request from 'superagent';
import B from 'bluebird';
import * as R from 'ramda';
import { UserError } from '@branchjs/tools.errors';

import { UNAVAILABLE_SOURCE_DASHBOARD } from '../../../../shared/constants';
import { ORG_VIEW, AGENCY_VIEW, APP_VIEW_ID_FIELD, ORG_VIEW_ID_FIELD } from '../../common/support/viewConstants';
import { openLogoutModal } from '../actions/LogoutModalActions';

const { view } = window.App.context;

const app_id = R.path([APP_VIEW_ID_FIELD], view);
const organization_id = R.path([ORG_VIEW_ID_FIELD], view);

const sendOrgIdHeader = view && (view.current_view === ORG_VIEW || view.current_view === AGENCY_VIEW);

var promises = {};

const redux = {
  store: {
    dispatch: () => {},
  },
};

export const serverReduxSetup = (store) => {
  redux.store = store;
};

export default function (name, data, files) {
  var cacheName = name + '--' + JSON.stringify(data);
  if (!files && promises[cacheName]) {
    return promises[cacheName];
  }
  var promise = new B(function (resolve, reject) {
    var k,
      req = request
        .post('/v1/callback/' + name)
        .set('X-Branch-Dashboard', 'dashboard')
        .set('x-csrf-token', window._csrfToken)
        .set('X-Client-Redirect', 'dashboard');

    if (sendOrgIdHeader) {
      req.set('x-organization-id', organization_id);
    } else {
      req.set('x-app-id', app_id);
    }

    if (files) {
      for (k in data) {
        if (data.hasOwnProperty(k)) {
          req = req.field(k, JSON.stringify(data[k]));
        }
      }
      for (k in files) {
        if (files.hasOwnProperty(k) && files[k] instanceof File) {
          req = req.attach(k, files[k], files[k].name);
        }
      }
    } else {
      req = req.send(data);
    }

    req.end(function (err, res) {
      if (res.status === StatusCodes.IM_A_TEAPOT && res?.body?.source === UNAVAILABLE_SOURCE_DASHBOARD) {
        return location.reload();
      }
      if (res.body && res.body['X-Client-Redirect']) {
        redux.store.dispatch(openLogoutModal());
      }
      if (res.status === 401) {
        redux.store.dispatch(openLogoutModal());
      }
      if (R.path(['response', 'body'], err)) {
        if (err.response.body.hasOwnProperty('status')) {
          if (err.response.body.code === 401) {
            redux.store.dispatch(openLogoutModal());
          }
          const { message, field } = err.response.body;
          return reject(new UserError(message, field));
        }
      }
      if (err || !res.body) {
        return reject((err && err.message) || err);
      }
      if (res.body.status) {
        resolve(res.body.value);
      } else {
        if (res.body.code === 401) {
          redux.store.dispatch(openLogoutModal());
        }
        reject(new UserError(res.body.message, res.body.field));
      }
    });
  });

  if (!files) {
    promises[cacheName] = promise;
    setTimeout(function () {
      promises[cacheName] = null;
    }, 10);
  }

  return promise;
}
